export default "__VITE_ASSET__BX81xfXs__"